
import Vue from "vue"
import VueResource from "vue-resource"
Vue.use(VueResource)


export default {
    $account:null,
    //host:"https://localhost:5001/", //本地测试
    //host:"https://jd.lhcoffeetime.com/",
    host:"/", //正式发布
    //天地图逆编码host
    tdhost:"http://api.tianditu.gov.cn/",
    minimaphost:"https://api.map.baidu.com/",
    lang:'zh',
    get(url,param,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.get(this.host+url,
            {
                params:{...param},
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                        ...headers,
                    Lang:this.lang,
                }
            }
        )
    },

    getForLocation(url,param,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.get(this.tdhost+url,
            {
                params:{...param},
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                        ...headers,
                    Lang:this.lang,
                }
            }
        );
    },

    postForLocation(url,body,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.post(this.minimaphost+url,body,
            {
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                    ...headers,
                    Lang:this.lang,
                }
            }
        );
    },

    post(url,body,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.post(this.host+url,body,
            {
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                    ...headers,
                    Lang:this.lang,
                }
            }
        );
    },


    put(url,body,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.put(this.host+url,body,
            {
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                    ...headers,
                    Lang:this.lang,
                }
            }
        );
    },

    delete(url,param,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.delete(this.host+url,
            {
                params:{...param},
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                        ...headers,
                    Lang:this.lang,
                }

            }
        );
    },
    download(url,param,headers){
      this.lang = localStorage.getItem('languageSet')||'zh'
      return Vue.http.get(this.host+url,
            {
                params:{...param},
                headers: {
                    Authorization: "Bearer " + (this.$account.data!=null?this.$account.data.token:""),
                        ...headers,
                    Lang:this.lang,
                },
                responseType: 'blob'
            }
        );
    }
}

//export  service;



// WEBPACK FOOTER //
// ./src/service/HttpService.js